<template>
  <div v-if="cards && cards.length" class="bottom-summary px-6 py-16 md:px-16">
    <div class="flex flex-col items-center gap-10 md:flex-row md:justify-center md:items-start md:gap-16 lg:gap-24">
      <BottomSummaryCard
        v-for="(card, index) of cards"
        :key="card.uid || index"
        :card="card"
        :data-testid="`bottom-summary-card-${index}`"
      />
    </div>
  </div>
</template>

<script lang="ts">
import { defineComponent } from 'vue'
import BottomSummaryCard from '@/components/molecules/BottomSummaryCard/index.vue'
import { BottomSummaryPP } from '@/model'

export default defineComponent({
  name: 'BottomSummary',
  components: {
    BottomSummaryCard
  },
  props: {
    cards: {
      type: Array as () => BottomSummaryPP[],
      default: () => []
    }
  }
})
</script>
